module.exports = __webpack_public_path__ + "static/media/visa.d1139329.svg";